import $axios from '@/helpers/axios-instance';

const baseUrl = process.env.API_ADMIN_URL;

export default {
  getTeachers(schoolCode) {
    return $axios.get(`api/Schools/GetTeachersForSchool/${schoolCode}`, {
      baseURL: baseUrl,
    });
  },
  getLastTeacherSignIn(schoolCode) {
    return $axios.get(`api/Schools/GetLastTeacherSignIn/${schoolCode}`, {
      baseURL: baseUrl,
    });
  },
  getPagedTeachers(paging) {
    return $axios.post('api/Schools/GetPagedTeachers', paging, {
      baseURL: baseUrl,
    });
  },

  newTeacher(teacher) {
    return $axios.post('api/Schools/NewTeacher', teacher, { baseURL: baseUrl });
  },
  updateTeacher(teacher) {
    return $axios.put('api/Schools/UpdateTeacher', teacher, {
      baseURL: baseUrl,
    });
  },
  removeTeacher(id) {
    return $axios.delete(`api/Schools/RemoveTeacher/${id}`, {
      baseURL: baseUrl,
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/admin.js